import React from 'react';
import { ScanLine, Share2, Search } from 'lucide-react';

const cards = [
  {
    icon: ScanLine,
    label: 'Capture',
    body: 'Connect your email and drive once. Every message, file, and decision starts flowing into one place.',
  },
  {
    icon: Share2,
    label: 'Structure',
    body: 'Approvals, selections, specs, timelines: it all becomes a live project record. No tagging. No sorting.',
  },
  {
    icon: Search,
    label: 'Compound',
    body: "Knowledge doesn't reset between projects. Every job makes your studio smarter.",
  },
];

const CaptureConnectReuseSection = () => {
  return (
    <section className="bg-[#ECE6DF] pt-2 md:pt-2 pb-10 md:pb-12">
      <div className="max-w-[1240px] mx-auto px-6 md:px-10">
        <div className="text-center max-w-3xl mx-auto animate-[fadeUp_0.7s_ease-out_both]">
          <div className="w-12 h-px bg-[#CBBBA3] mx-auto mb-7" />
          <p className="text-[#7A5A2E] text-[12px] tracking-[0.24em] uppercase mb-4">
            Archen™ gives your studio a memory
          </p>
          <h2
            className="text-[#1F1812] leading-[1.08] tracking-[-0.02em]"
            style={{
              fontFamily: "'Cormorant Garamond', serif",
              fontWeight: 500,
              fontSize: 'clamp(1.8rem, 3.4vw, 2.6rem)',
            }}
          >
            Capture. Structure. Compound.
          </h2>
        </div>

        <div className="mt-8 md:mt-10 grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-0">
          {cards.map((card, i) => {
            const Icon = card.icon;
            return (
              <div
                key={card.label}
                className={`flex items-center gap-3.5 md:px-5 lg:px-6 animate-[fadeUp_0.7s_ease-out_both] ${
                  i > 0 ? 'md:border-l md:border-[#E2D9CB]' : ''
                }`}
                style={{ animationDelay: `${i * 120 + 120}ms` }}
              >
                <Icon size={32} strokeWidth={1.5} className="text-[#7A5A2E] flex-shrink-0" />
                <div>
                  <h3
                    className="text-[#1F1812] text-[24px] mb-2"
                    style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 500 }}
                  >
                    {card.label}
                  </h3>
                  <p className="text-[#5C4F42] text-[14px] leading-[1.55]">{card.body}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <style>{`
        @keyframes fadeUp { from { opacity: 0; transform: translateY(18px); } to { opacity: 1; transform: translateY(0); } }
      `}</style>
    </section>
  );
};

export default CaptureConnectReuseSection;
